
import React, { useEffect, useRef, useState } from "react";
import sideImage from "./orgenic.avif";
const Landinggrocerypage = () => {
    const textRef = useRef(null);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setAnimate(true);
            },
            { threshold: 0.3 }
        );
        if (textRef.current) observer.observe(textRef.current);
        return () => {
            if (textRef.current) observer.unobserve(textRef.current);
        };
    }, []);

    return (
        <div style={styles.container}>
            {/* Top Center About Heading */}
            <h2 style={styles.sectionHeading}>Groceries And Services</h2>

            <div style={styles.wrapper} className="main-home-about">
                {/* Left Animated Text */}
                <div
                    ref={textRef}
                    style={{
                        ...styles.left,
                        transform: animate ? "translateY(0px)" : "translateY(50px)",
                        opacity: animate ? 1 : 0,
                        transition: "all 0.8s ease",
                    }}
                    className="lading-abouts"
                >
                    <h1 style={styles.heading}>Groceries And Services</h1>
                    <p style={styles.description}>
                        At <strong>Maamaas</strong>, we make everyday grocery shopping simple,
                        smart, and local. Whether you’re a supermarket, a local store, or an
                        organic supplier — our platform helps you reach your customers directly,
                        without intermediaries or hidden costs.
                        <br /><br />
                        Manage your entire catalog of fruits, vegetables, grains, and household
                        essentials from one easy-to-use dashboard. Update stock in real time,
                        set prices, and offer deals — all while your customers shop comfortably
                        from their homes.
                        <br /><br />

                    </p>
                </div>

                {/* Right Image */}
                <div style={styles.right} className="lading-about">
                    <img src={sideImage} alt="Groceries and Essentials" style={styles.image} />
                </div>
            </div>
        </div>


    );
};

// ✅ Inline Styles
const styles = {
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 10px",
    },
    sectionHeading: {
        textAlign: "center",
        fontSize: "28px",
        fontWeight: "bold",
        fontFamily: "'SF Pro', sans-serif",
        color: "#b15cd6",
        marginBottom: "10px",
        marginTop: "0px",
    },
    wrapper: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center", // ✅ Align items vertically
        justifyContent: "space-between",
        gap: "30px", // ✅ Gap between text and image
        width: "100%",
        maxWidth: "64vw",
        backgroundColor: "#f9f9f9",
        padding: "30px 20px",
        borderRadius: "12px",
    },
    left: {
        flex: "1 1 50%",
        // minWidth: "280px",
        marginTop: "10px",
    },
    right: {
        flex: "1 1 45%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // minWidth: "260px",
        marginTop: "10px",
    },
    heading: {
        fontSize: "2rem",
        fontWeight: "bold",
        marginBottom: "15px",
        color: "#222",
    },
    description: {
        fontSize: "1rem",
        lineHeight: "1.6",
        color: "#555",
    },
    image: {
        width: "100%",
        maxWidth: "350px",
        height: "auto",
        borderRadius: "10px",
        objectFit: "cover",
    },
};

export default Landinggrocerypage;
